<template>
  <div class="center-warp">
    <div class="inner">
      <div class="box-filter-line d-flex-between">
        <div class="box-search d-flex-between">
<!--          <input type="text" placeholder="关键词" v-model="queryParams.keyWords" @keydown.enter="handleQuery">-->
          <Input :placeholder="'关键词'" v-model="queryParams.keyWords" @enter="handleQuery"/>
          <div class="iconfont icon-sousuo" @click="handleQuery"></div>
        </div>
        <el-date-picker
          format="yyyy-MM-dd"
          value-format="yyyy-MM-dd"
          class="box-data box-data-date"
          v-model="queryParams.date_range"
          type="daterange"
          @change="handleQuery"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期">
        </el-date-picker>
        <el-dropdown trigger="click" @command="handleTypeCommand">
          <div class="box-data d-flex-between">
            <div :class="queryParams.tab_type == undefined ? 'placeholder' : ''">{{queryParams.tab_type == undefined ? '分类' : tabTypeDict[queryParams.tab_type]}}</div>
            <div class="iconfont icon-xialaanniu"></div>
          </div>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item :command="key" v-for="(item, key) in tabTypeDict" :key="key">{{item}}</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
        <el-dropdown trigger="click" @command="handleCateCommand">
          <div class="box-data d-flex-between">
            <div :class="queryParams.message_type == undefined ? 'placeholder' : ''">{{queryParams.message_type == undefined ? '类型' : messageTypeDict[queryParams.message_type]}}</div>
            <div class="iconfont icon-xialaanniu"></div>
          </div>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item :command="key" v-for="(item, key) in messageTypeDict" :key="key">{{item}}</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
        <div class="box-btn" @click="resetQuery">重置</div>
      </div>
      <div class="box-table" v-loading="loading">
        <div class="box-table-tr box-table-head black-14">
          <div>序号</div>
          <div>内容</div>
          <div>创建时间</div>
          <div>分类</div>
          <div>类型</div>
          <div>操作</div>
        </div>
        <div class="box-table-tr black-14" v-for="(row, index) in list" :key="index" @click="openFile(row)" :style="row.message_type == 2 ? 'cursor: pointer;' : ''">
          <div>{{ index+1 }}</div>
          <div v-if="row.message_type == 0">{{row.content}}</div>
          <div v-else-if="row.message_type == 1">
            <el-image style="max-width:220px" :src="row.target_url" fit="contain" :preview-src-list="[row.target_url]"></el-image>
          </div>
          <div v-else-if="row.message_type == 2">{{row.abstract_info}}</div>
          <div>{{ row.created_at.substring(0,11) }}</div>
          <div v-if="login_member_id && row.member_id == login_member_id">我的</div>
          <div v-else>通用</div>
          <div>{{messageTypeDict[row.message_type]}}</div>
          <div class="box-tr-del" v-if="login_member_id && row.member_id == login_member_id" @click.stop="handleDelete(row)">删除</div>
        </div>
        <Empty v-if="!list.length" :img-width="'200px'" :info="'暂无内容'" />
      </div>
      <Pagination :total="total" :page.sync="queryParams.page" :last_page="last_page" @pagination="getList" :key="queryParams.page" />
    </div>
  </div>
</template>

<script>
import { search, deleteById } from "@/http/box";
import Pagination from "@/components/Pagination";

export default {
  name: "index",
  components: { Pagination },
  data() {
    return {
      list: [],
      total: 0,
      last_page: 0,
      loading: false,
      queryParams: {
        page: 1,
        pageSize: 20,
        keyWords: undefined,
        tab_type: undefined,
        message_type: undefined,
        date_range: undefined,
      },
      tabTypeDict: { 1: "我的", 2: "通用" },
      messageTypeDict: { 0: "文本", 1: "图片", 2: "文件" },
      login_member_id: undefined,
    };
  },
  created() {
    var member = JSON.parse(localStorage.getItem("member"));
    this.login_member_id = member.id;
    this.getList();
  },
  methods: {
    getList() {
      this.loading = true;
      search(this.queryParams)
        .then((res) => {
          this.list = res.data.data;
          this.total = res.data.total;
          this.last_page = res.data.last_page;
          this.loading = false;
        })
        .catch(() => {
          this.loading = false;
        });
    },
    handleTypeCommand(command) {
      this.queryParams.tab_type = command;
      this.handleQuery();
    },
    handleCateCommand(command) {
      this.queryParams.message_type = command;
      this.handleQuery();
    },
    resetQuery() {
      this.queryParams = {
        page: 1,
        pageSize: 20,
        keyWords: undefined,
        tab_type: undefined,
        message_type: undefined,
        date_range: undefined,
      };
      this.getList();
    },
    handleQuery() {
      this.queryParams.page = 1;
      this.getList();
    },
    handleDelete(row) {
      var self = this;
      this.$confirm("确认要删除吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          self.loading = true;
          return deleteById({ id: [row.id] });
        })
        .then((res) => {
          self.loading = false;
          console.log(res);
          if (res.code == 200) {
            this.$message({
              type: "success",
              message: "删除成功!",
            });
          } else {
            this.$message.error(res.message[0] ? res.message[0] : "删除失败");
          }
          this.getList();
        })
        .catch(() => {
          self.loading = false;
          // this.$message({
          //   type: "info",
          //   message: "已取消删除",
          // });
        });
    },
    openFile(row){
      if(row.message_type == 2) window.open(row.target_url, '_blank');
    }
  },
};
</script>

<style scoped src="../../assets/css/box.css">
</style>>
<style>
.box-data-date {
  width: 240px !important;
  border: none;
}
.box-data-date .el-range-separator{
  padding: 0;
  width: 10%;
}
.box-data-date .el-range__close-icon{
  display: none;
}
.box-data-date input {
  padding: 0 !important;
  border: none;
  height: 32px;
}
.box-btn {
  padding: 0 12px;
  height: 32px;
  background: #ffffff;
  border-radius: 6px;
  cursor: pointer;
  font-size: 14px;
  font-weight: 500;
  color: #333333;
  line-height: 32px;
  width: 66px;
  text-align: center;
}
</style>
